<!-- Main menu -->
<div class="yllw-sidenav__section-header" [class.yllw-sidenav__section-header--collapsed]="!expanded()">
    @if (expanded()) {
        <span class="yllw-sidenav__section-text">{{ "HEADER.OVERVIEW" | translate }}</span>
    }
</div>
<app-sidenav-section [section]="mainItems()" [expanded]="expanded()" />


<!-- Admin -->
@if (showAdminSection()) {
<div class="yllw-sidenav__section-header" [class.yllw-sidenav__section-header--collapsed]="!expanded()">
    @if (expanded()) {
        <span class="yllw-sidenav__section-text">{{ "ADMIN.TITLE" | translate }}</span>
    }
</div>
<ul class="yllw-sidenav__menu">
    @if (canAccessCentralSupport()) {
    <app-sidenav-group
        [group]="centralSupportGroup"
        [expanded]="expanded()"
        [open]="centralSupportOpen()"
        [active]="isCentralSupportActive()"
        [flyoutOpen]="flyoutGroup() === 'central-support'"
        [flyoutPositions]="flyoutPositions"
        (toggle)="toggleCentralSupport()"
        (openFlyoutRequest)="openFlyout('central-support')"
        (scheduleClose)="scheduleCloseFlyout()"
        (cancelClose)="cancelCloseFlyout()"
        (closeFlyout)="closeFlyout()" />
    }
    @if (canAccessContractAdmin()) {
    <app-sidenav-group
        [group]="contractAdminGroup"
        [expanded]="expanded()"
        [open]="contractAdminOpen()"
        [active]="isContractAdminActive()"
        [flyoutOpen]="flyoutGroup() === 'contract-admin'"
        [flyoutPositions]="flyoutPositions"
        (toggle)="toggleContractAdmin()"
        (openFlyoutRequest)="openFlyout('contract-admin')"
        (scheduleClose)="scheduleCloseFlyout()"
        (cancelClose)="cancelCloseFlyout()"
        (closeFlyout)="closeFlyout()" />
    }
    @if (isSuperUser()) {
    <app-sidenav-group
        [group]="superUserGroup"
        [expanded]="expanded()"
        [open]="superUserOpen()"
        [active]="isSuperUserActive()"
        [flyoutOpen]="flyoutGroup() === 'super-user'"
        [flyoutPositions]="flyoutPositions"
        (toggle)="toggleSuperUser()"
        (openFlyoutRequest)="openFlyout('super-user')"
        (scheduleClose)="scheduleCloseFlyout()"
        (cancelClose)="cancelCloseFlyout()"
        (closeFlyout)="closeFlyout()" />
    }
    @if (isDeveloper()) {
    <app-sidenav-group
        [group]="developerGroup"
        [expanded]="expanded()"
        [open]="developerOpen()"
        [active]="isDeveloperActive()"
        [flyoutOpen]="flyoutGroup() === 'developer'"
        [flyoutPositions]="flyoutPositions"
        (toggle)="toggleDeveloper()"
        (openFlyoutRequest)="openFlyout('developer')"
        (scheduleClose)="scheduleCloseFlyout()"
        (cancelClose)="cancelCloseFlyout()"
        (closeFlyout)="closeFlyout()" />
    }
</ul>
}

<!-- Help -->
<div class="yllw-sidenav__section-header" [class.yllw-sidenav__section-header--collapsed]="!expanded()">
    @if (expanded()) {
        <span class="yllw-sidenav__section-text">{{ "HELP.SECTION_TITLE" | translate }}</span>
    }
</div>
<app-sidenav-section [section]="helpItems" [expanded]="expanded()" />
